 <!-- <div *ngIf="appointment === null">
START: <input [(ngModel)]="startTime" /><br>{{startTime}}
<br>
END: <input [(ngModel)]="endTime" /><br>{{endTime}}
<br>
<button (click)="startCreateAppointmentClicked()">Start Create appointment</button>
</div> -->



<div class="calendar-page-wrap">


<!-- <div class="appointment-creator-wrap" [ngClass]="{'open' : appointment !== null}">
  <ubc-appointment-creator
  *ngIf="appointment !== null"
  [appointment]="appointment"
  (wasCancelled)="cancelCreateAppointmentClicked()"
  (wasCreated)="appointmentWasCreated()"
  ></ubc-appointment-creator>
</div> -->

<section class="calendar-section" [ngClass]="{'reduced' : appointment !== null}">


  <div class="calendar-wrap w-full">
    <!-- <full-calendar #calendar
      header="{
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      }"
      nowIndicator="true"
      aspectRatio = "calendarRatio"
      businessHours="businessHours"
      deepChangeDetection ="true"
      (datesRender) = "viewWasRendered()"
      events = "calendarEvents"
      (eventRender)="calendarEventRender($event)"
      defaultView="dayGridMonth"
      plugins="calenderPlugins"
      (dateClick)="handleDateClick($event)"
      (eventClick)="handleEventClick($event)"
      (eventDrop)="eventWasDragged($event)"
      (eventResize)="eventWasResized($event)"
      firstDay="1"
      minTime="'06:00:00'"
      maxTime="'20:00:00'"
    ></full-calendar> -->
    <full-calendar *ngIf="readyForCalendar" #calendar 
      [options]="calendarOptions" 
      (datesRender) = "viewWasRendered()"
      [events]="calendarEvents"
      deepChangeDetection="true"
      ></full-calendar>

      <div class="absolute bottom right-0 p-2 bg-white bg-opacity-70 flex gap-2 text-xs">
        <div class="flex gap-2">
          <div class="w-6 h-6 bg-teal-400 rounded-full"></div>
          Bridle Fitting
        </div>
      </div>
  </div>

  

</section>

</div>

<!-- <ubc-appointment-edit-slideover #appointmentEditSlideover (wasClosed)="appointmentDetailsWasClosed()"></ubc-appointment-edit-slideover> -->

<div class="py-3 absolute left-0 top-0 w-full bg-accent bg-opacity-80 font-medium text-white text-center flex justify-center" *ngIf="gettingGoogleEvents">
  <ubc-spinner></ubc-spinner>
  <span class="ml-4">Refreshing Google Events</span></div>